import React from 'react'
import { Link } from 'gatsby'
import * as typeformEmbed from '@typeform/embed'
// import AnchorLink from 'react-anchor-link-smooth-scroll'

const Links = ({ path }) => {
  let typeForm
  if (process && process.browser) {
    typeForm = typeformEmbed.makePopup(
      "https://vinayjain749949.typeform.com/to/Clx7dr",
      {
        opacity: 55,
        buttonText: "Request Invite",
        hideScrollbars: true,
        onSubmit: function () {
          setTimeout(() => typeForm.close(), 2000)
        }
      }
    )
  }
  return <>
    {path === "/" ?
      <Link
        className="nav-link text-dark-gray font-family-secondary nav-link"
        offset='50'
        to="#features">
        Features
      </Link>
      :
      <Link
        to="/#features"
        className="nav-link text-dark-gray font-family-secondary nav-link"
        activeStyle={{
          color: "#5897f4",
        }}>
        Features
      </Link>}
    {path === "/" ?
      <Link
        className="nav-link text-dark-gray font-family-secondary nav-link"
        offset='50'
        to="#team">
        Team
      </Link>
      :
      <Link
        to="/#team"
        className="nav-link text-dark-gray font-family-secondary nav-link"
        activeStyle={{
          color: "#5897f4",
        }}>
        Team
      </Link>}
    {/* eslint-disable-next-line */}
    <a
      href="#"
      onClick={() => {
        process && process.browser &&
          typeForm.open()
      }}
      className="nav-link text-dark-gray font-family-secondary nav-link"
    >Request Invite</a>
    <Link
      to="/faq"
      className="nav-link text-dark-gray font-family-secondary nav-link"
      activeStyle={{
        color: "#5897f4",
      }}>
      FAQ
    </Link>
    {/* eslint-disable-next-line */}
    <a
      // href="mailto:info@pirlo.io"
      href="#"
      onClick={() => {
        process && process.browser &&
          typeForm.open()
      }}
      className="nav-link text-dark-gray font-family-secondary nav-link"
    >Contact Us</a>
    {/* {
      visible ?
        highlight ?
          <li className="nav-item d-none d-lg-block m-1">
            {target ?
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-md btn-secondary text-uppercase font-family-secondary sm-font-size px-3 font-weight__500 ml-2"
              >
                {title}
              </a>
              :
              <Link
                to={url}
                className="btn btn-md btn-secondary text-uppercase font-family-secondary sm-font-size px-3 font-weight__500 ml-2"
              >
                {title}
              </Link>
            }
          </li>
          :
          <li className="nav-item ml-lg-2 my-auto">
            {
              target ?
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link text-dark-gray font-family-secondary nav-link"
                >
                  {title}
                </a>
                :
                externalLink ?
                  <a
                    href={url}
                    className="nav-link text-dark-gray font-family-secondary nav-link"
                  >
                    {title}
                  </a>
                  :
                  hashValue ?
                    path === "/" ?
                      <AnchorLink
                        className="nav-link text-dark-gray font-family-secondary nav-link"
                        offset='50'
                        href={url}>
                        {title}
                      </AnchorLink>
                      :
                      <Link
                        to={url}
                        className="nav-link text-dark-gray font-family-secondary nav-link"
                        activeStyle={{
                          color: "#5897f4",
                        }}>
                        {title}
                      </Link>
                    :
                    <Link
                      to={url}
                      className="nav-link text-dark-gray font-family-secondary nav-link"
                      activeStyle={{
                        color: "#5897f4",
                      }}>
                      {title}
                    </Link>
            }
          </li>
        :
        null
    } */}
  </>
}
export default class NavLinks extends React.Component {
  render() {
    const path = this.props.path
    return (
      <Links path={path} />
    )
  }
}
